import styled from 'styled-components';

const PostWritingContainer = styled.div`
  border: 1px solid #a8b7be;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  background: #fff;
  padding: 24px;
`;

export default PostWritingContainer;
